import { FIXED_REPORT_MODE } from '@racemap/sdk/schema/trackers';
import { RacemapColors } from '@racemap/utilities/consts/common';
import { formatSeconds } from '@racemap/utilities/formatting';
import type { TableCellProps } from 'react-virtualized';
import { getConcatenatedKey } from 'src/components/utils/getConcatenatedKey';
import {
  type ManagedTracker,
  TrackerColumnKeys,
} from '../../../../store/trackers/trackers_reducers';
import { Columns } from '../../../DataTable';
import { IconFailCircle } from '../../../Icon';

interface CellProps extends TableCellProps {
  cellData?: ManagedTracker['state'];
  rowData: ManagedTracker;
}

export const MovementColumn = () => {
  const cellRenderer = ({ rowData }: CellProps) => {
    if (
      rowData.setting?.moveCheckInterval == null &&
      rowData.setting?.moveSendInterval == null &&
      rowData.setting?.reportMode == null
    ) {
      return <IconFailCircle color={RacemapColors.BaseRed} />;
    }

    const moveCheckInterval = formatSeconds(rowData.setting.moveCheckInterval);

    const moveSendInterval = formatSeconds(rowData.setting.moveSendInterval);
    const reportModeLabels = {
      [FIXED_REPORT_MODE.NONE]: 'None',
      [FIXED_REPORT_MODE.DISABLED]: 'Off',
      [FIXED_REPORT_MODE.ENABLED]: 'Time',
      [FIXED_REPORT_MODE.DISTANCE]: 'Dist',
      [FIXED_REPORT_MODE.MILEAGE]: 'Mile',
      [FIXED_REPORT_MODE.OPTIMUM]: 'Opt',
      [FIXED_REPORT_MODE.TIME_OR_MILEAGE]: 'Time/ Mile',
    };

    const selectedReportMode = rowData.setting?.reportMode;
    const reportModeLabel =
      selectedReportMode != null ? reportModeLabels[selectedReportMode] : '--';

    return (
      <div>
        {moveCheckInterval} / {moveSendInterval} / {reportModeLabel}
      </div>
    );
  };

  return Columns.sortingColumn({
    dataKey: TrackerColumnKeys.MOVEMENT,
    label: 'Movement',
    hint: 'Shows movement settings with check interval, send interval, and report mode options, such as off, time-based, distance-based, mileage, or optimal reporting.',
    cellRenderer,
    minWidth: 150,
    columnData: { hiddenOnDefault: true },
    sortingMethod: (_cA, _cB, rowDataA: ManagedTracker, rowDataB: ManagedTracker) => {
      const keyA = getConcatenatedKey([
        rowDataA.setting?.moveCheckInterval,
        rowDataA.setting?.moveSendInterval,
        rowDataA.setting?.reportMode,
      ]);
      const keyB = getConcatenatedKey([
        rowDataB.setting?.moveCheckInterval,
        rowDataB.setting?.moveSendInterval,
        rowDataB.setting?.reportMode,
      ]);

      return keyA.localeCompare(keyB);
    },
  });
};
